import lang from "src/assets/lang.json";
import iso from "src/assets/iso.json";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { Router } from "@angular/router";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { ListContent, ListProductItem } from "src/app/core/services/outbound";
import {
  user_role_color_map,
  user_role_map,
  user_search_placeholder_map,
  user_status_color_map,
  user_status_map,
} from "src/app/core/services/constants";
import { CommonService } from "src/app/sharedservices/common.service";

@Component({
  selector: "app-contents-selector",
  templateUrl: "./contents-selector.component.html",
  styleUrls: ["./contents-selector.component.scss"],
  providers: [],
})

/**
 * Contacts domain-list component
 */
export class ContentsSelectorComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() mode = "list";
  @Input() single = false;
  @Input() selectedProducts = [];
  @Input() className: string[];
  @Output() selectedNotifier = new EventEmitter<any>();
  @Output() cancelNotifier = new EventEmitter<boolean>(false);
  // bread crumb items
  breadCrumbItems: Array<{}>;
  page: Array<any> = [];
  eop = false;
  pageSize = 24;
  currentPage = 0;
  contentList: {};
  contentListSubscription: any;
  monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  status_map = {};
  status_color_map = {};
  user_search_placeholder_map = {};
  user_role_map = {};
  user_role_color_map = {};
  payload = {};
  contentListForm: UntypedFormGroup;
  submitted = false;
  dupe = false;
  criterionCount = 0;
  component_ref: any;
  search_message = "";
  countries = [];
  loading = false;
  verifySubscription: any;
  my_id: any;

  selectedProductsList = {};

  contentTypes = [
    {
      label: "Image",
      value: "image",
    },
    {
      label: "Video",
      value: "video",
    },
    {
      label: "Audio",
      value: "audio",
    },
    {
      label: "URL",
      value: "url",
    },
    {
      label: "Location",
      value: "location",
    },
    // {
    //   label: "Audio playlist",
    //   value: "audio_playlist",
    // },
    // {
    //   label: "Video playlist",
    //   value: "video_playlist",
    // },
    // {
    //   label: "Album",
    //   value: "album",
    // },
  ];

  constructor(
    private ws: WebsocketService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    private commonService: CommonService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // console.log(this.router.url);
    this.countries = iso.map((a) => a.name);
    this.status_map = user_status_map;
    this.status_color_map = user_status_color_map;
    this.user_role_map = user_role_map;
    this.user_role_color_map = user_role_color_map;
    this.user_search_placeholder_map = user_search_placeholder_map;

    // console.log(this.countries);
    this.component_ref = this.mdw.makeRef(16);
    this.currentPage = 0;
    this.contentList = {};
    // console.log(Object.keys(this.userList).length);

    this.contentListForm = this.formBuilder.group({
      chat_id: new UntypedFormControl(null),
      created_date: new UntypedFormControl(null),
      search_type: new UntypedFormControl("name"),
      search_value: new UntypedFormControl(null),
      type: new UntypedFormControl(''),
      status: new UntypedFormControl(""),
      category: new UntypedFormControl(""),
    });

    this.contentListSubscription =
      this.ws.listContentResponseContainer$.subscribe((listContentsData) => {
        if (listContentsData.ref === this.component_ref) {
          if (listContentsData) {
            this.loading = false;
            this.currentPage = listContentsData.page_number;
            if (listContentsData.data.length == 0 && this.currentPage == 1) {
              this.search_message = "No results matched your search criteria";
            }

            listContentsData.data.forEach((content: any) => {
              content.created_date = new Date(content.created_date);
              content.created_date =
                content.created_date.getDate() +
                " " +
                this.monthNames[content.created_date.getMonth()] +
                ", " +
                content.created_date.getFullYear();
              // product.country_alpha = iso.find((e) => e.code == product.country_code)?.alpha;

              this.contentList[String(content.id)] = content;
            });
            // console.log(Object.keys(this.userList).length);

            this.page = [];
            for (let i = 0; i < this.pageSize; i++) {
              if (
                Object.keys(this.contentList)[
                  i + (this.currentPage - 1) * this.pageSize
                ]
              ) {
                this.page.push(
                  this.contentList[
                    Object.keys(this.contentList)[
                      i + (this.currentPage - 1) * this.pageSize
                    ]
                  ]
                );
              }
            }

            document
              .getElementById("pagination_back")
              .classList.remove("d-none");
            document
              .getElementById("pagination_back")
              .classList.add("enablePointer");
            document
              .getElementById("pagination_next")
              .classList.remove("d-none");
            document
              .getElementById("pagination_next")
              .classList.add("enablePointer");

            this.eop = false;
            if (listContentsData.eop) {
              this.eop = true;
              document
                .getElementById("pagination_next")
                .classList.add("d-none");
              document
                .getElementById("pagination_next")
                .classList.remove("enablePointer");
            } else {
              document
                .getElementById("pagination_next")
                .classList.remove("d-none");
              document
                .getElementById("pagination_next")
                .classList.add("enablePointer");
            }
            if (this.currentPage == 1) {
              document
                .getElementById("pagination_back")
                .classList.add("d-none");
              document
                .getElementById("pagination_back")
                .classList.remove("enablePointer");
            } else {
              document
                .getElementById("pagination_back")
                .classList.remove("d-none");
              document
                .getElementById("pagination_back")
                .classList.add("enablePointer");
            }
            if (this.currentPage == 1 && listContentsData.eop) {
              document
                .getElementById("showPageNumber")
                .classList.add("invisible");
            } else {
              document
                .getElementById("showPageNumber")
                .classList.remove("invisible");
            }
            this.ref.detectChanges();
          }
        }
      });

    this.verifySubscription = this.ws.verifyContainer$.subscribe(
      (verifyData) => {
        // console.log("verifyData"+ verifyData);
        if (verifyData) {
          this.payload["category"] = this.className;
          this.my_id = this.mdw.getID();
          this.loading = true;
          this.ws.processMethod(
            new ListContent(this.currentPage, this.pageSize, this.component_ref)
          );
        }
      }
    );

    if (this.selectedProducts && this.selectedProducts.length > 0) {
      for (let i = 0; this.selectedProducts.length > i; i++) {
        this.selectedProductsList[this.selectedProducts[i].content_id] =
          this.selectedProducts[i];
      }
    }

    this.breadCrumbItems = [
      { label: "MENUITEMS.STOREMANGER.TEXT" },
      { label: "PRODUCTS.PRODUCTS", active: true },
    ];
  }

  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.contentListSubscription) {
      this.contentListSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    document.getElementById("pagination_back").classList.add("d-none");
    document
      .getElementById("pagination_back")
      .classList.remove("enablePointer");
    document.getElementById("pagination_next").classList.add("d-none");
    document
      .getElementById("pagination_next")
      .classList.remove("enablePointer");
  }

  openDetails(data: any) {
    this.router.navigate([
      "/" +
        data.account_id +
        "/" +
        data.ref_domain +
        "/" +
        data.service.product,
    ]);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.contentListForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.contentListForm.valid) {
      this.loading = true;

      let id =
        this.f.search_type.value === "content"
          ? this.f.search_value.value
          : null;
      let name =
        this.f.search_type.value === "name" ? this.f.search_value.value : null;
      let created_date = this.f.created_date.value
        ? this.commonService.dateFormat(this.f.created_date.value)
        : null;
      let status = this.f.status.value;
      let category = this.f.category.value;
      let type = this.f.type.value;
      this.search(id, name, created_date, status, category, type);
    } else {
      return;
    }
  }

  search(
    id: any,
    name: any,
    created_date: any,
    status: any,
    category: string,
    type: string
  ) {
    this.currentPage = 0;
    this.contentList = {};
    this.payload = {};
    this.search_message = "";

    this.payload = {
      page_size: this.pageSize,
      page_number: 0,
      chat_id: localStorage.getItem("app_id"),
    };

    if (id != null && id !== "") {
      this.payload["content_id"] = id;
    }
    if (name != null && name !== "") {
      this.payload["name"] = name;
    }
    if (created_date != null && created_date !== "") {
      this.payload["created_date"] = created_date;
    }
    if (status != null && status !== "") {
      this.payload["status"] = status;
    }
    if (category != null && category !== "") {
      this.payload["category"] = [category];
    } else {
      this.payload["category"] = ["product", "digital"];
    }

    if (type != null && type !== "") {
      this.payload["type"] = type;
    }

    this.ws.processMethod(
      new ListContent(
        this.currentPage,
        this.pageSize,
        this.component_ref,
        this.payload["name"],
        this.payload["content_id"],
        this.payload["created_date"],
        this.payload["type"],
        this.payload["status"]
      )
    );
  }
  resetSearch() {
    this.currentPage = 0;
    this.contentList = {};
    this.search_message = "";

    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("app_id");
    this.payload["category"] = ["product", "digital"];

    this.ws.processMethod(
      new ListContent(this.currentPage, this.pageSize, this.component_ref)
    );
  }

  nextPage() {
    // console.log("request");
    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("app_id");

    this.ws.processMethod(
      new ListContent(
        this.currentPage,
        this.pageSize,
        this.component_ref,
        this.payload["name"],
        this.payload["content_id"],
        this.payload["created_date"],
        this.payload["type"],
        this.payload["status"]
      )
    );
  }

  backPage() {
    if (this.currentPage != 1) {
      this.currentPage--;
      this.page = [];
      for (let i = 0; i < this.pageSize; i++) {
        if (
          Object.keys(this.contentList)[
            i + (this.currentPage - 1) * this.pageSize
          ]
        ) {
          this.page.push(
            this.contentList[
              Object.keys(this.contentList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ]
          );
        }
      }
      if (this.currentPage == 1) {
        document.getElementById("pagination_back").classList.add("d-none");
        document
          .getElementById("pagination_back")
          .classList.remove("enablePointer");
      }
      if (
        this.currentPage <
        Object.keys(this.contentList).length / this.pageSize
      ) {
        document.getElementById("pagination_next").classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");
      }
    }
  }

  selectProduct(data) {
    if (this.single) {
      if (this.selectedProductsList[data.id]) {
        delete this.selectedProductsList[data.id];
      } else {
        this.selectedProductsList = {};
        this.selectedProductsList[data.id] = data;
      }
    } else {
      if (this.selectedProductsList[data.id]) {
        delete this.selectedProductsList[data.id];
      } else {
        this.selectedProductsList[data.id] = data;
      }
    }
  }

  insertEvent() {
    const selected = Object.values(this.selectedProductsList);
    this.selectedNotifier.emit(selected);
  }

  cancelEvent() {
    this.cancelNotifier.emit(true);
  }

  isObjEmpty() {
    return Object.keys(this.selectedProductsList).length === 0;
  }

  isSelected(id: string) {
    return this.selectedProductsList[id] ? true : false;
  }

  getDisplayImages(data) {
    switch (data.type) {
      case "image":
      case "album":
        return data?.content?.media && data?.content?.media[0]
          ? data?.content?.media[0]?.url
          : null;
      case "video":
      case "video_playlist":
        return data?.content?.media && data?.content?.media[0]
          ? data?.content?.media[0]?.thumbnail_url
          : null;
      case "location":
      case "url":
      case "audio":
      case "audio_playlist":
        return data?.content?.image && data?.content?.image[0]
          ? data?.content?.image[0]?.url
          : null;
    }
  }
}
